import Box from "@mui/material/Box";
import {
    Card,
    FormControl,
    InputLabel,
    Typography
} from "@mui/material";
import NTextField from "../../nasbai-design/NTextField";
import React from "react";
import {NSelect} from "../../nasbai-design/NSelect";
import MenuItem from "@mui/material/MenuItem";
import NButtonDark from "../../nasbai-design/NButtonDark";
import {useSignal} from "@preact/signals-react";
import {useNavigate} from "react-router-dom";
import apiService from "../../hooks/apiService";
import {useSnackbarStore} from "../../stores/snackbarStore";


const CancelPage = () => {

    const formDataSignal = useSignal({
        email: '',
        type: '',
        roc: ''
    });
    const snackbar = useSnackbarStore();
    const navigate = useNavigate();

    function onSubmit(e: any) {
        if (formDataSignal.value.email && formDataSignal.value.type) {
            apiService.cancelRequest(formDataSignal.value.email, formDataSignal.value.type, formDataSignal.value.roc).then(response => {
                snackbar.showSnackbar(response.data, "success");
            }).catch(error => {
                if (error.status === 404) {
                    snackbar.showSnackbar("Email or Subscription not found!", "error");
                } else {
                    snackbar.showSnackbar(error.response.data, 'error');
                }
            })
            e.preventDefault();
        } else {
            snackbar.showSnackbar("please fill out every field", "warning")
        }

    }

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const {name, value} = e.target;
        formDataSignal.value = {
            ...formDataSignal.value,
            [name]: value
        }
    };

    const handleSelectChange = (event: any) => {
        const {value} = event.target;
        formDataSignal.value = {
            ...formDataSignal.value,
            type: value
        };
    }

    return (
        <Box sx={{
            mt: '70px',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            height: '87vh'
        }}>
            <Card elevation={3}
                  sx={{p: 2, display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center'}}>
                <Typography variant="h4" sx={{ mb: 5 }}>Cancel your Subscription</Typography>
                <Typography variant="body1">Please enter your email associated with your Nasbai account. <br/>
                    Fill out this form and submit it to proceed with the cancellation.<br/> After submitting, you will
                    receive an email asking you to confirm the cancellation. <br/>
                    You can also <a href="https://nasbai.com/api/auth" onClick={() => navigate('/api/auth')} >login </a>
                    and directly cancel it in your account settings</Typography>
                <form style={{width: '100%'}} onSubmit={onSubmit}>
                    <NTextField
                        label="email"
                        margin="normal"
                        name="email"
                        size="small"
                        required
                        fullWidth
                        value={formDataSignal.value.email || ''}
                        onChange={(event) => handleInputChange(event)}
                    />
                    <FormControl fullWidth margin="normal">
                        <InputLabel id="type-label"
                                    sx={{color: (t) => t.palette.text.primary}}>Type of Cancellation</InputLabel>
                        <NSelect
                            labelId="type-label"
                            label="Type of Cancellation"
                            variant="outlined"
                            required
                            value={formDataSignal.value.type}
                            onChange={(event) => handleSelectChange(event)}
                        >
                            <MenuItem value="normal">
                                Normal
                            </MenuItem>
                            <MenuItem value="extraordinary">
                                Extraordinary
                            </MenuItem>
                        </NSelect>
                    </FormControl>

                    {
                        formDataSignal.value.type === 'extraordinary' &&
                        <NTextField
                            label="reason of cancellation"
                            multiline
                            required={formDataSignal.value.type === 'extraordinary'}
                            margin="normal"
                            name="roc"
                            size="small"
                            fullWidth
                            value={formDataSignal.value.roc || ''}
                            onChange={(event) => handleInputChange(event)}
                        />
                    }
                    <Typography>* required Fields</Typography>
                    <NButtonDark fullWidth sx={{mt: 2}} type="submit">
                        request Cancellation
                    </NButtonDark>
                </form>
            </Card>
        </Box>
    );
}

export default CancelPage;